module.exports = __webpack_public_path__ + "img/400.09a6249.svg";